<new-flowbanner [showPromo]="true"></new-flowbanner>
<section class="general-pausa">
  <div class="container d-flex justify-content-center align-items-center vh-60">
    <form class="w-100 w-md-50 p-4" [formGroup]="contactForm" (ngSubmit)="enviarFormulario()">
      <div class="text-center mb-4">
        <h2 class="cotizacion-heading">Cotización en pausa</h2>
        <p class="cotizacion-text">
          Tenemos otro producto disponible para ti. Déjanos tus datos y nos
          pondremos en contacto contigo ;)
        </p>
      </div>

      <div class="mb-3 cotizacion-input-container">
        <label for="nombre" class="form-label cotizacion-label" [ngClass]="getLabelClasses('nombre')">*Nombre</label>
        <input
          id="nombre"
          type="text"
          class="form-control cotizacion-input"
          formControlName="nombre"
          placeholder="Escribe tu nombre"
          [class.is-invalid]="isValidField('nombre')"
        />
        <div *ngIf="isValidField('nombre')" class="invalid-feedback">
          {{ getFieldError('nombre') }}
        </div>
      </div>

      <div class="mb-3 cotizacion-input-container">
        <label for="celular" class="form-label cotizacion-label" [ngClass]="getLabelClasses('celular')"
          >*Número de celular</label
        >
        <input
          id="celular"
          type="text"
          class="form-control cotizacion-input"
          formControlName="celular"
          placeholder="Ej: 3004263078"
          [class.is-invalid]="isValidField('celular')"
        />
        <div *ngIf="isValidField('celular')" class="invalid-feedback">
          {{ getFieldError('celular') }}
        </div>
      </div>

      <div class="mb-3 cotizacion-input-container">
        <label for="correo" class="form-label cotizacion-label" [ngClass]="getLabelClasses('correo')"
          >*Correo electrónico</label
        >
        <input
          id="correo"
          type="email"
          class="form-control cotizacion-input"
          formControlName="correo"
          placeholder="Ej: nombre@correo.com"
          [class.is-invalid]="isValidField('correo')"
        />
        <div *ngIf="isValidField('correo')" class="invalid-feedback">
          {{ getFieldError('correo') }}
        </div>
      </div>

      <div class="mb-3 cotizacion-input-small">
        <small class="cotizacion-small">*Los campos son obligatorios</small>
      </div>

      <button type="submit" class="btn btn-primary d-flex justify-content-center align-items-center" [disabled]="contactForm.invalid">Enviar</button>
    </form>
  </div>
</section>

<app-footer-app></app-footer-app>
